import { useEffect, useState } from 'react';
import { RegionService } from '../../services';

const useGetListProvinces = (params = {}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [listOfProvinces, setListOfProvinces] = useState([]);
  const [totalProvinces, setTotalProvinces] = useState(0);

  useEffect(() => {
    setIsLoading(true);
    RegionService.getListProvinces({
      keyword: params?.keyword,
    })
      .then((res) => {
        const { data, count } = res;
        setListOfProvinces(data);
        setTotalProvinces(count);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [params?.keyword]);

  return {
    isLoading,
    data: listOfProvinces,
    total: totalProvinces,
  };
};

const useGetListDistricts = (params = {}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [listOfDistricts, setListOfDistricts] = useState([]);
  const [totalDistricts, setTotalDistricts] = useState(0);

  useEffect(() => {
    setIsLoading(true);
    RegionService.getListDistricts({
      keyword: params?.keyword,
      provinceCode: params?.provinceCode,
    })
      .then((res) => {
        const { data, count } = res;
        setListOfDistricts(data);
        setTotalDistricts(count);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [params?.keyword, params?.provinceCode]);

  return {
    isLoading,
    data: listOfDistricts,
    total: totalDistricts,
  };
};

export default {
  useGetListProvinces,
  useGetListDistricts,
};
